import { Outlet } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { FeatureWall } from 'modules/core/components/FeatureWall'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import CollectionsBootstrap from 'modules/performance_feedbacks/lib/CollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()

  return (
    <ResponsivePage.Body
      header={{
        title: i18n.t('performance_feedbacks.pages.feedbacks_index.title'),
        description: i18n.t('performance_feedbacks.pages.feedbacks_index.description'),
        illustration: 'performance_management',
      }}
      widget={
        <Button.Router to={navigation.performanceFeedbacks.giveFeedback.fullPath()}>
          {i18n.t('performance_feedbacks.pages.give_feedback.title')}
        </Button.Router>
      }
    >
      <Box gridColSpan={{ xxs: 12, xs: 8, l: 6 }} gap="s32">
        <Outlet />
      </Box>
    </ResponsivePage.Body>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <FeatureWall featureName="dev_performance_feedback">
        <Container />
      </FeatureWall>
    </CollectionsBootstrap>
  )
}

export default RootPage
